<template>
  <div style="background-color:#F0F2F5">
    <div style="height:100px;background-color:#ffffff;">
      <img class="logo" :src="logosrc" />
    </div>
    <div v-show="!submitpageShow" style="height:125px;background-color:#ffffff;margin-top:10px">提交成功</div>
    <div v-show="submitpageShow">
      <div style="height:125px;background-color:#ffffff;margin-top:10px">
        <div style="text-align:left">
          <label class="content-label">个人信息</label>
        </div>
        <div style="width:auto;height:1px;margin-top:5px;margin-left:20px;margin-right:20px;background-color:#D5D5D5;overflow:hidden;"></div>
        <div style="text-align:left;margin-top:10px;display:flex">
          <label style="font-size:12px;margin-left:95px;margin-top:5px">姓名</label>
          <input class="el-input__inner" size="mini" style="width:100px;margin-left:5px;height:25px;font-size:12px" v-model="name"/>
        </div>
        <div style="text-align:left;margin-top:10px;display:flex">
          <label style="font-size:12px;margin-left:20px;margin-top:15px">手机尾号（后四位)</label>
          <input class="el-input__inner" size="mini" style="width:100px;margin-left:5px;margin-top:10px;height:25px;font-size:12px" v-model="phoneNumber"/>
        </div>
      </div>
      <div style="background-color:#ffffff;margin-top:10px">
        <div style="text-align:left;">
          <label class="content-label">年龄</label>
        </div>
        <div style="width:auto;height:1px;margin-top:5px;margin-left:20px;margin-right:20px;background-color:#D5D5D5;overflow:hidden;"></div>
        <div style="text-align:left;margin-left:20px;margin-right:20px;margin-top:10px;">
          <el-radio-group v-model="ageRange">
            <el-radio label="12 - 17岁" style="margin-top:10px"></el-radio>
            <el-radio label="18 - 25岁" style="margin-top:10px"></el-radio>
            <br />
            <el-radio label="26 - 40岁" style="margin-top:20px"></el-radio>
            <el-radio label="41 - 60岁" style="margin-top:20px"></el-radio>
            <br />
            <el-radio label="60岁以上" style="margin-top:20px;margin-bottom:15px"></el-radio>
          </el-radio-group>
        </div>
      </div>
      <div style="height:90px;background-color:#ffffff;margin-top:10px">
        <div style="text-align:left;">
          <label class="content-label">性别</label>
        </div>
        <div style="width:auto;height:1px;margin-top:5px;margin-left:20px;margin-right:20px;background-color:#D5D5D5;overflow:hidden;"></div>
        <div style="text-align:left;margin-left:20px;margin-right:20px;margin-top:10px;">
          <el-radio-group v-model="gender">
            <el-radio label="男" style="margin-top:10px"></el-radio>
            <el-radio label="女" style="margin-top:20px;margin-bottom:15px"></el-radio>
          </el-radio-group>
        </div>
      </div>
      <div style="height:90px;background-color:#ffffff;margin-top:10px">
        <div style="text-align:left;">
          <label class="content-label">亲属关系（选填）</label>
        </div>
        <div style="width:auto;height:1px;margin-top:5px;margin-left:20px;margin-right:20px;background-color:#D5D5D5;overflow:hidden;"></div>
        <div style="text-align:left;margin-top:10px;display:flex">
          <label style="font-size:12px;margin-left:20px;margin-top:15px">亲属编号</label>
          <input class="el-input__inner" size="mini" style="width:100px;margin-left:5px;margin-top:10px;height:25px;font-size:12px" v-model="kinsfolkNum"/>
        </div>
        <div style="text-align:left;margin-left:20px;margin-right:20px;margin-top:10px;">
          <el-radio-group v-model="kinsfolk">
            <el-radio label="双胞胎" style="margin-top:10px"></el-radio>
            <el-radio label="亲兄弟姐妹" style="margin-top:20px;margin-bottom:15px"></el-radio>
            <el-radio label="表兄弟姐妹" style="margin-top:20px;margin-bottom:15px"></el-radio>
          </el-radio-group>
        </div>
        <el-button type="primary" size="mini" style="margin-top:20px;margin-bottom:30px" @click="submit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/js/utils/config";
import { Loading } from "element-ui";
export default {
  name: "PersonInfo",
  data() {
    return {
      code: "",
      submitpageShow: true,
      logosrc: require("@/assets/logo1.png"),
      name: "",
      phoneNumber: "",
      ageRange: "",
      gender: "",
      kinsfolkNum: "",
      kinsfolk: "",
      phoneNumberMaxLength: 4
    };
  },
  created() {
    let path = window.location.href;
    let splits = path.split("/");
    this.code = splits[splits.length - 1];
  },
  watch: {
    phoneNumber: function(val) {
      if (!val) return;
      if (val.length > this.phoneNumberMaxLength) {
        let newValue = String(val).slice(0, this.phoneNumberMaxLength);
        this.phoneNumber = newValue;
      }
      if (!/^[0-9]\d*$/.test(val)) {
        this.phoneNumber = String(val).slice(0, val.length - 1);
      }
    },
    kinsfolkNum: function(val) {
      if (!val) return;
      if (!/^[0-9]\d*$/.test(val)) {
        this.kinsfolkNum = String(val).slice(0, val.length - 1);
      }
    }
  },
  methods: {
    showErrorMessage(message) {
      this.$message({
        message: message,
        type: "error",
        duration: 1500
      });
    },
    checkInfo() {
      //个人信息、年龄、性别必填
      let result = { code: 200, message: "" };
      if (this.name.length == 0 || this.phoneNumber.length == 0) {
        result = { code: 500, message: "个人信息为必填项" };
      } else if (this.phoneNumber.length < 4) {
        result = { code: 500, message: "请输入手机尾号（后四位）" };
      } else if (this.ageRange.length == 0) {
        result = { code: 500, message: "年龄为必填项" };
      } else if (this.gender.length == 0) {
        result = { code: 500, message: "性别为必填项" };
      }

      return result;
    },

    submit() {
      //校验参数
      let result = this.checkInfo();
      if (result.code != 200) {
        this.showErrorMessage(result.message);
        return;
      }
      let loadingInstance = Loading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let url = config.api.codeinfo;
      let params = {
        code: this.code,
        age_range: this.ageRange,
        gender: this.gender,
        phone_number: this.phoneNumber,
        name: this.name,
      };

      if (this.kinsfolk) {
        params["kinsfolk"] = this.kinsfolk;
      }
      if (this.kinsfolkNum) {
        params["kinsfolk_num"] = parseInt(this.kinsfolkNum);
      }
      this.HttpUtils.post(url, params)
        .then(result => {
          this.submitpageShow = false;
          console.log(result);
          loadingInstance.close();
        })
        .catch(execption => {
          console.log(execption);
          loadingInstance.close();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  margin-top: 30px;
  justify-content: center;
  width: 117px;
  height: 41px;
}
.content-label {
  font-size: 12px;
  margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/js/modules/personinfo/personinfo.vue